import * as React from 'react';
import {Element, scroller} from "react-scroll";
import JsonRenderComponent from "../../../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";

interface IProps {
    personId?: string;
    response?: any;
    heading?: string;
}

function scrollToTopOfResults() {
    scroller.scrollTo("update-identity-validation-status-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class UpdateIdentityValidationStatusResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                {this.props.response && <h4>{this.props.heading}</h4>}
                <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>
                    <Alert variant="filled" severity="info">
                        Please see below identity validation status for person id: '{this.props.personId}'
                    </Alert>

                    {this.props.response && scrollToTopOfResults()}

                    <Element name="update-identity-validation-status-result"/>
                    <JsonRenderComponent jsonObject={this.props.response} printHtml={false}/>
                </p>
            </div>
        );
    }
}

export default UpdateIdentityValidationStatusResult;
